import Vue from "vue";

import BootstrapVue from "bootstrap-vue";
import '../assets/scss/main.scss';

Vue.use(BootstrapVue);
